import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import I18n from 'I18n';
import * as OfferingType from 'marketplace-ui-common/offerings/constants/OfferingType';
import { ecosystemAppClient, ecosystemPublicClient } from 'marketplace-ui-common/clients/ecosystemClient';
import { TYPEAHEAD_SEARCH_RESULTS_LIMIT } from 'marketplace-ui-common/constants/search';
import AssetSearchBarResult from '../components/AssetSearchBarResult';
import { getModuleMarketplaceUrl, getThemeMarketplaceUrl } from '../../utils/urls';
export const VIEW_ALL_THEMES = '__VIEW_ALL_THEMES__';
export const VIEW_ALL_MODULES = '__VIEW_ALL_MODULES__';
export function useAssetSearchBarQuery({
  appContext = 'app',
  isUngatedForUnifiedSearch = false,
  grouped = false,
  limit = TYPEAHEAD_SEARCH_RESULTS_LIMIT,
  offeringType = 'THEME'
} = {}) {
  const offeringTypeIsModule = offeringType === OfferingType.MODULE;
  const searchUrl = offeringTypeIsModule ? 'modules/search' : 'themes/search';
  const offering = offeringTypeIsModule ? 'module' : 'theme';
  const VIEW_ALL_ASSETS = offeringTypeIsModule ? VIEW_ALL_MODULES : VIEW_ALL_THEMES;
  const fetcher = useCallback(input => {
    const client = appContext === 'public' ? ecosystemPublicClient : ecosystemAppClient;
    const response = client.post(searchUrl, {
      data: [{
        limit,
        search: input
      }]
    });
    const searchBarViewAllMessage = offeringTypeIsModule ? `marketplace-ui-assets-core.assets.moduleSearchBarViewAll` : `marketplace-ui-assets-core.assets.themeSearchBarViewAll`;
    const searchBarGroupLabelMessage = offeringTypeIsModule ? `marketplace-ui-assets-core.assets.moduleSearchBarGroupLabel` : `marketplace-ui-assets-core.assets.themeSearchBarGroupLabel`;
    return response.then(([{
      items,
      total
    }]) => {
      const getAssetUrl = (context, slug) => {
        return offeringTypeIsModule ? getModuleMarketplaceUrl(context, slug) : getThemeMarketplaceUrl(context, slug);
      };

      const options = items.map(item => {
        const {
          companyName,
          name,
          offeringId,
          slug,
          thumbnailUrl
        } = item;
        return {
          dropdownText: /*#__PURE__*/_jsx(AssetSearchBarResult, {
            companyName: companyName,
            isUngatedForUnifiedSearch: isUngatedForUnifiedSearch,
            name: name,
            offeringType: offeringType,
            thumbnailUrl: thumbnailUrl
          }),
          href: getAssetUrl(appContext, slug),
          item,
          linkUse: 'unstyled',
          text: name,
          value: `${offering}::${offeringId}`,
          slug
        };
      });

      if (total > limit) {
        options.push({
          href: getAssetUrl(appContext, `all?eco_search=${input}`),
          text: I18n.text(searchBarViewAllMessage, {
            total
          }),
          value: VIEW_ALL_ASSETS
        });
      }

      return options;
    }).then(options => grouped ? [{
      text: I18n.text(searchBarGroupLabelMessage),
      options
    }] : options);
  }, [appContext, isUngatedForUnifiedSearch, grouped, limit, offering, offeringType, offeringTypeIsModule, searchUrl, VIEW_ALL_ASSETS]);
  return fetcher;
}